module.exports = __webpack_public_path__ + "static/media/Tej.846118ec.JPEG";